<template>
  <div class="chart-content">
    <div class="chart" ref="myChart">
    </div>
  </div>
</template>

<script>
import elementResizeDetectorMaker from "element-resize-detector";
import BaseReportMixin from '@/mixin/baseReport-mixin.js'
// import {
//   GetPurchaseComparisonBySixMonths
// } from '@/api'
export default ({
  mixins: [BaseReportMixin],
  data () {
    return {
      myChart: null,
      option: {},
      barData: [],
      names: [],
      lineDate: [],
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    getDataAction: {
      type: Function,
      default () {
        return null
      }
    },
    leftName: {
      type: String,
      default () {
        return ''
      }
    },
    rightName: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {

    barData: {
      handler (newVal, oldVal) {
        this.initOption()
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    }, lineDate: {
      handler (newVal, oldVal) {
        this.initOption()
        this.option.series[1].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    },

  },
  methods: {
    // 获取列表
    getData () {
      this.getDataAction({})
        .then(res => {
          this.names = res.returnData.map(e => e.name);
          this.barData = res.returnData.map(e => e.value);
          this.lineDate = res.returnData.map(e => e.lineValue);
        })
    },
    initOption () {
      let that = this;
      this.option = {
        title: {
          text: this.name,
          textStyle: {
            color: "#FFF" // 标题颜色
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        legend: {
          top: '90%', // 图例位置
          textStyle: {
            color: "#FFF" // 图列颜色
          },
        },
        toolbox: {
          show: true,
          iconStyle: {
            borderColor: "#FFF", // 图标默认颜色
          },
          emphasis: {
            iconStyle: {
              borderColor: "#FFF",// 图标hover颜色
            },
          },
        },
        dataZoom: {
          show: false,
          start: 0,
          end: 100
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            data: this.names,
            // splitLine: {
            //   show: false
            // }
            axisLabel: {//底部文字设置
              color: "#a9a6b8"
            },
            axisLine: {
              lineStyle: {
                color: '#a9a6b8'
              } // x轴坐标轴颜色
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: this.leftName,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameLocation: 'start', //坐标轴名称显示位置。 底部
            nameGap: 22, //坐标轴名称与轴线之间的距离。 上下
            nameTextStyle: {
              color: "#fff",//"#65ABE7", // 蓝色(金额/万元)
              fontSize: 12,
            },
            axisLine: {
              show: true,//坐标轴线
              lineStyle: {
                color: '#a9a6b8'
              }
            },
            splitLine: {
              show: false// 去掉坐标横线
            },
            axisTick: {
              show: true//刻度 -
            },
          },
          {
            type: 'value',
            scale: true,
            name: this.rightName,
            min: 0,
            boundaryGap: [0.2, 0.2],
            nameLocation: 'start', //坐标轴名称显示位置。 底部
            nameGap: 22, //坐标轴名称与轴线之间的距离。
            nameTextStyle: {
              color: "#fff",//"orange", // 橙色（数量）
              fontSize: 12,
            },
            axisLine: {
              show: true,//坐标轴线
              lineStyle: {
                color: '#a9a6b8'
              }
            },
            splitLine: {
              show: false // 去掉坐标横线
            },
            axisTick: {
              show: true //刻度 -
            },
          },


        ],
        series: [
          {
            name: this.leftName,
            type: 'bar',
            data: this.barData,

            barWidth: 20, //柱图宽度
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    { offset: 0.2, color: '#007ffd' },                 //柱图渐变色
                    { offset: 0, color: '#0177d4' },                   //柱图渐变色
                    { offset: 1, color: '#063692' },                   //柱图渐变色
                  ]
                )
              },
              // emphasis: {
              //   color: new this.$echarts.graphic.LinearGradient(
              //     0, 0, 0, 1,
              //     [
              //       { offset: 0, color: '#71C8B1' },                  //点击柱图高亮渐变色
              //       { offset: 0.7, color: '#44C0C1' },                //柱图高亮渐变色
              //       // { offset: 1, color: '#06B5D7' }                //柱图高亮渐变色
              //     ]
              //   )
              // }
            },
          },
          {
            name: this.rightName,
            type: 'line',
            yAxisIndex: 1,

            data: this.lineDate,
            itemStyle: {
              normal: {
                color: 'orange'
              }
            }
          },
        ],
        toolbox: this.getToolBox(this),

        grid: {
          left: '18%',
          right: '18%',
          show: false
        }
      }
      // X、Y 双轴对齐
      // this.option.yAxis[0].max = Math.ceil(Math.max.apply(null, this.option.series[0].data) / 5) * 5;
      // this.option.yAxis[0].interval = Math.ceil(Math.max.apply(null, this.option.series[0].data) / 5);
      // this.option.yAxis[1].max = Math.ceil(Math.max.apply(null, this.option.series[1].data) / 5) * 5;
      // this.option.yAxis[1].interval = Math.ceil(Math.max.apply(null, this.option.series[1].data) / 5);
    },


    init () {
      this.initOption()
      // this.option.width = this.width
      // this.option.height = this.height
      this.myChart = this.$echarts.init(this.$refs['myChart'])
      this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      const _this = this
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.myChart, (e) => {
        _this.$nextTick(() => {
          _this.myChart.resize();
          var parentNodeId = e.parentNode.parentElement.id
          var domId = document.getElementById(parentNodeId);
          _this.$emit('SizeChange', domId.clientWidth, domId.clientHeight, parentNodeId)
        })
      })
    },

  },//自定义指令

  mounted () {
    this.init()
    // this.getData();
    let that = this

    this.setInterval = setInterval(function () {
      that.getData();
    }, 5 * 60 * 1000);//每隔1秒执行每次刷新数据的函数
    // (function () {
    //   that.init();//这个是预加载 把报表的框架加载出来
    // })
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getData();
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: 400px;
  height: 300px;
  display: flex;
  .chart {
    width: 100%;
    height: 100%;
    position: absolute; // 拖动时报表随div缩放
  }
}
// .tag-list {
//   display: list-item;
//   line-height: 40px;
//   width: 190px;
//   padding: 4% 0;
//   .tag-text {
//     color: #fff;
//     margin-left: 10px;
//     font-size: 14px;
//   }
// }
</style>
